export default __webpack_public_path__ + "static/media/trampapo_02_23.29d9bc77.jpg";